import styled from 'styled-components/macro';

import Dialog from 'components/ui/Dialog';
import { border } from 'variables/general';

export const ModalContentWrapper = styled.div`
  display: flex;
  min-height: 0;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 1.5em;
  padding-right: 1.5em;
  border-right: ${border};

  .hidden {
    visibility: hidden;
  }
`;

export const RightContainer = styled.div`
  width: 22em;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const SchedulerSection = styled.div`
  margin-top: 3em;
  padding-top: 3em;
  border-top: ${border};
`;

export const StyledModal = styled(Dialog)`
  .MuiDialogContent-root {
    display: flex;
    flex-direction: column;
  }

  .rbc-calendar {
    .rbc-toolbar {
      display: flex;
      flex-direction: column;
      flex-flow: column-reverse;
      align-items: baseline;
      align-self: baseline;
    }

    .rbc-btn-group {
      &:last-of-type {
        display: none;
      }
    }

    .rbc-toolbar-label {
      margin-bottom: 1.5em;
      font-size: 1em;
      text-align: left;
    }

    .rbc-event {
      padding: 0;
    }

    .rbc-event-label {
      display: none;
    }

    .rbc-event-content {
      padding: 0.2em 0.5em;
      font-size: 12px;
    }
  }
`;
